import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { currencyFormat } from '../../constants';
import useApplication from '../../resources/applications/read';
import PromoAlert from './PromoAlert';

const RevolverOfferDetails = () => {
  const { data: application } = useApplication();

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#FAFAFA',
        borderRadius: theme.spacing(2),
        border: '1px solid #0000003B',
        padding: '12px 16px 16px 16px',
      })}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          columnGap: 1.5,
          mb: 3,
        }}
      >
        <CreditCardIcon color="primary" sx={{ mt: 0.5 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography variant="h2">
            {currencyFormat.format(application.attributes.total_credit)}
          </Typography>
          <Typography variant="subtitle1">
            ExpressWay Credit Line
          </Typography>
          <Typography variant="body2" textAlign="left">
            Use your ExpressWay card to purchase products and services at
            participating service centers.
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2">
          Line of Credit
        </Typography>
        <Typography variant="subtitle2">
          {currencyFormat.format(application.attributes.total_credit)}
        </Typography>
      </Box>
      <Divider sx={{ mt: 0.5, mb: 0.5 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2">
          APR
        </Typography>
        <Typography variant="subtitle2">
          33.99%
        </Typography>
      </Box>
      <Divider sx={{ mt: 0.5, mb: 0.5 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2">
          Annual Fee
        </Typography>
        <Typography variant="subtitle2">
          {currencyFormat.format(application.attributes.annual_fee)}
        </Typography>
      </Box>
      {application.attributes.offer_type !== 'EXPRESSWAY_NO_PROMO' && <PromoAlert />}
    </Box>
  );
};

export default RevolverOfferDetails;
